import styled from 'styled-components';
import {viewSize} from '../../../config';

export const Container = styled.div`
	width: 100%;
	max-width: 1100px;
	margin: 0 auto;
	border-top: 1px solid #e5e5e5;
`;

export const Item = styled.div`
	width: 100%;
	border-bottom: 1px solid #e5e5e5;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: #fafafa;
	}
`;

export const QuestionRow = styled.div`
	display: flex;
	align-items: center;
	padding: 22px 10px;
	font-size: 17px;

	@media screen and (max-width: ${viewSize.tablet}) {
		padding: 18px 6px;
		font-size: 15px;
	}
`;

export const QMark = styled.span`
	color: #1f8f88;
	font-weight: 600;
	margin-right: 12px;
`;

export const QuestionText = styled.span`
	color: #333;
`;

export const AnswerWrapper = styled.div`
	overflow: hidden;
	transition: max-height 0.4s ease, opacity 0.3s ease, padding 0.3s ease;

	max-height: ${({$open}) => ($open ? '1000px' : '0')};
	opacity: ${({$open}) => ($open ? 1 : 0)};
	padding: ${({$open}) => ($open ? '24px 20px' : '0 20px')};
	background: #f5f5f5;
`;

export const AnswerInner = styled.div`
	padding-top: 10px;
`;

export const AnswerRow = styled.div`
	display: flex;
	align-items: flex-start;
`;

export const AMark = styled.span`
	color: #e74c3c;
	font-weight: 600;
	margin-right: 12px;
`;

export const AnswerText = styled.div`
	color: #666;
	line-height: 1.8;
	font-size: 15px;
	white-space: pre-line;
`;

export const AnswerImage = styled.img`
	margin-top: 16px;
	max-width: 100%;
	border-radius: 6px;
`;
